import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Button,
  IconButton,
  Box,
  Typography,
  Grid
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./LogicModal.scss";

export default function LogicModal({ open, onClose }) {
  const [description, setDescription] = useState("");
  const [tag, setTag] = useState("");
  const [stamp, setStamp] = useState("");
  const [attachments, setAttachments] = useState([]);

  // Add Files
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    const fileObjects = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      id: Math.random().toString(36).substring(7),
    }));

    setAttachments((prev) => [...prev, ...fileObjects]);
  };

  // Remove File
  const handleRemove = (id) => {
    setAttachments((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>
        Logic <span style={{ color: "red" }}>*</span>
      </DialogTitle>

      <DialogContent className="logic-modal">

        {/* Description */}
        <TextField
          multiline
          rows={5}
          fullWidth
          placeholder="Write a brief description..."
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          sx={{
            "& .MuiInputBase-input": {
              fontSize: "14px"
            },
            mb: 3
          }}
        />

        {/* Tags + Stamps Row */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} md={6}>
            <Typography className="field-label">
              Tags <span>*</span> <small>(Min 3)</small>
            </Typography>

            <TextField
              select
              fullWidth
              size="small"
              value={tag}
              onChange={(e) => setTag(e.target.value)}
              className="custom-dropdown"
              SelectProps={{
                displayEmpty: true,
                renderValue: (selected) => {
                  if (!selected) {
                    return <span style={{ color: "#999" }}>Logic Tags</span>;
                  }
                  return selected;
                }
              }}
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: "14px"
                },
                mb: 3
              }}
            >
              <MenuItem value="breakout">Breakout</MenuItem>
              <MenuItem value="scalp">Scalp</MenuItem>
              <MenuItem value="intraday">Intraday</MenuItem>
            </TextField>
          </Grid>
        </Grid>

        {/* Upload Section */}
        <Box className="upload-row">
          <label className="upload-btn">
            Upload +
            <input type="file" hidden multiple onChange={handleFileChange} />
          </label>

          <Typography className="attachment-count">
            Attachments - {attachments.length}
          </Typography>
        </Box>

        {/* Preview Grid */}
        <Box className="preview-grid">
          {attachments.map((item) => (
            <Box key={item.id} className="preview-card">
              <img src={item.preview} alt="preview" />

              <IconButton
                size="small"
                className="remove-btn"
                onClick={() => handleRemove(item.id)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          ))}
        </Box>

        {/* Footer */}
        <Box className="logic-footer">
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>

          <Button className="publish-btn" variant="contained" >
            Publish
          </Button>
        </Box>

      </DialogContent>
    </Dialog>
  );
}